export function getArgumentGroupDOMId(argumentGroupId: string | null) {
  return `argument-group-${argumentGroupId || "none"}`
}
